import { Route, Routes } from 'react-router'

import { SUB_PATH } from '../../utils/routes'
import { NotFound } from '../common/NotFound'
import { Edit } from './Edit'
import { ListView as List } from './List'

export const AddressMappings = () => {
  return (
    <Routes>
      <Route path="update/:region/:privateIp" element={<Edit />} />
      <Route path={SUB_PATH.NEW} element={<Edit />} />
      <Route index element={<List />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
